import React from "react";
import { useCurrencySymbol } from "hooks";
import { getPriceString } from "components/Price/Price.utils";
import { Typography } from "@shared/ui.primitives";

type Props = {
  price: number;
  isTypical?: boolean;
  isDiscount?: boolean;
};

export const Price: React.FC<Props> = ({
  price,
  isTypical = false,
  isDiscount = false
}) => {
  const currencySym = useCurrencySymbol();
  const priceString = getPriceString(price, currencySym, isTypical, isDiscount);

  return (
    <Typography
      as="span"
      variant="subheader-6"
      colour="accent-dark"
    >{`up to ${priceString}`}</Typography>
  );
};
